export default "__VITE_ASSET__Dqu9BQkU__"